export const VIEW_CANCELLATION = 52
export const VIEW_CANCELLATION_SUMMARY = 85
export const EXPORT_CANCELLATION_SUMMARY = 86
export const VIEW_CANCELLATION_LIST = 87
export const EXPORT_CANCELLATION_LIST = 88
export const EDIT_CANCELLATION = 93
